class ctxDisableCtrlClickDirective {
    constructor() {
        this.restrict = 'A';
    }

    link(scope, element, attrs) {
        element.click(e => {
            if (e.ctrlKey || e.button == 2) {
                return false;
            }
        });
    }

    static directiveFactory() {
        return new ctxDisableCtrlClickDirective();
    }
}

ctxDisableCtrlClickDirective.directiveFactory.$inject = [];

module.exports = ctxDisableCtrlClickDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/utils/ctxDisableCtrlClick.directive.js